/**
 * Hotjar Tracking Script Component
 * Integrates Hotjar analytics using Contentsquare tag SDK
 */

"use client";

import { useEffect } from 'react';
import { injectContentsquareScript } from '@contentsquare/tag-sdk';

export default function HotjarScript() {
  useEffect(() => {
    // Only inject on client side
    if (typeof window !== 'undefined') {
      try {
        injectContentsquareScript({
          siteId: "6437617",
          async: true, // Load script asynchronously for better performance
          defer: false // Don't defer execution
        });
        
        console.log('✅ Hotjar script injected successfully');
      } catch (error) {
        console.error('❌ Failed to inject Hotjar script:', error);
      }
    }
  }, []);

  // This component doesn't render anything visible
  return null;
}